import { useQuery } from "@tanstack/react-query";

import { getAllUserVerificationFarmTasks } from "services";

import { getFarmIdFromLocalStorage } from "utils";

import { DEFAULT_CACHE_TIME, GET_ALL_USER_VERIFICATION_FARM_TASKS } from "consts";

import { VerificationsFarmTasks } from "models";

export const useGetAllUserVerificationFarmTasks = (farmId?: string) => {
  const farmIdLocalStorage = getFarmIdFromLocalStorage();

  return useQuery<VerificationsFarmTasks[]>({
    queryKey: [GET_ALL_USER_VERIFICATION_FARM_TASKS, farmId ?? farmIdLocalStorage],
    queryFn: () => getAllUserVerificationFarmTasks({ farmId: farmId ?? farmIdLocalStorage }),
    gcTime: DEFAULT_CACHE_TIME,
    staleTime: DEFAULT_CACHE_TIME,
  });
};
